import CONVO_US from 'src/assets/images/convo-global-assets/Convo_US.svg';
import CONVO_AU from 'src/assets/images/convo-global-assets/Convo_AU.svg';
import ConvoNow from 'src/assets/images/ConvoNow.svg';
import ConvoFooter from 'src/assets/images/Convo_footer.svg';

type ConfigType = {
    [key: string]: {
        logoSrc: string;
        appName: string;
        newhelpIconUrl: string;
        oldhelpIconUrl: string;
        privacyPolicyUrl: string;
        androidLink: string;
        iosLink: string;
        webLink: string;
        accountInterestUrl: string;
        webSiteUrl: string;
        complimentaryCreditPlanName: string;
        minPhoneLength: number;
        HeaderLogo: string;
        FooterLogo: string;
        isUS: boolean;
        isAU: boolean;
        isUK: boolean;
        contactURL?: string;
        organizationSpelling: string;
        needHelpUrl: string;
        contactSupportUrl: string;
        helpCenterLabel: string;
        captchaSiteKey?: string;
        domain?: string;
    };
};

const Config: ConfigType = {
    US: {
        logoSrc: CONVO_US,
        appName: `${process.env.REACT_APP_PRODUCT_NAME}`,
        newhelpIconUrl: 'https://go.convo.io/us/convo-now-help',
        oldhelpIconUrl: 'https://rebrand.ly/ondemandhelp',
        privacyPolicyUrl: 'https://rebrand.ly/convolegal',
        androidLink: `https://play.google.com/store/apps/details?id=com.convo.vriapp.us`,
        iosLink: `https://apps.apple.com/us/app/convo-now/id6443850330`,
        webLink: `${process.env.REACT_APP_WEB_DOMAIN_URL}`,
        accountInterestUrl: `https://rebrand.ly/convonowweb`,
        webSiteUrl: 'https://go.convo.io/us',
        needHelpUrl: 'https://go.convo.io/us/need-help-login',
        contactSupportUrl: 'https://go.convo.io/us/chat-with-us',
        complimentaryCreditPlanName: `${process.env.REACT_APP_COMPLIMENTARY_CREDIT_PLAN_NAME}`,
        minPhoneLength: 3,
        HeaderLogo: ConvoNow,
        FooterLogo: ConvoFooter,
        isUS: true,
        isAU: false,
        isUK: false,
        organizationSpelling: 'organizations',
        helpCenterLabel: 'Help Center',
        captchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITEKEY,
        domain: 'convo.io',
    },
    AU: {
        logoSrc: CONVO_AU,
        appName: `${process.env.REACT_APP_PRODUCT_NAME}`,
        newhelpIconUrl: 'https://go.convo.io/au/help ',
        oldhelpIconUrl: 'https://www.convoaustralia.com/how-to',
        privacyPolicyUrl: 'http://www.convoaustralia.com/privacy',
        androidLink: `https://play.google.com/store/apps/details?id=com.convo.vriapp.au`,
        iosLink: `https://apps.apple.com/us/app/convo-now-au/id6473834812`,
        webLink: `${process.env.REACT_APP_WEB_DOMAIN_URL}`,
        accountInterestUrl: `http://www.convoaustralia.com/signup`,
        webSiteUrl: 'https://go.convo.io/au',
        needHelpUrl: 'https://go.convo.io/au/need-help-login',
        contactSupportUrl: 'https://go.convo.io/au/chat-with-us',
        complimentaryCreditPlanName: `${process.env.REACT_APP_COMPLIMENTARY_CREDIT_PLAN_NAME}`,
        minPhoneLength: 3,
        HeaderLogo: ConvoNow,
        FooterLogo: ConvoFooter,
        isUS: false,
        isAU: true,
        isUK: false,
        organizationSpelling: 'organisations',
        helpCenterLabel: 'Help Centre',
        captchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITEKEY,
        domain: 'au.convo.io',
    },
    UK: {
        logoSrc: CONVO_US,
        appName: `${process.env.REACT_APP_PRODUCT_NAME}`,
        newhelpIconUrl: 'https://go.convo.io/uk/help',
        oldhelpIconUrl: 'https://go.convo.io/uk/help',
        privacyPolicyUrl: 'https://go.convo.io/uk/legal',
        androidLink: `https://play.google.com/store/apps/details?id=com.convo.vriapp`,
        iosLink: `https://apps.apple.com/gb/app/id1545172283`,
        webLink: `${process.env.REACT_APP_WEB_DOMAIN_URL}`,
        accountInterestUrl: `https://rebrand.ly/convonowweb`,
        webSiteUrl: 'https://go.convo.io/uk',
        needHelpUrl: 'https://go.convo.io/uk/need-help-login',
        contactSupportUrl: 'https://go.convo.io/uk/chat-with-us',
        complimentaryCreditPlanName: `${process.env.REACT_APP_COMPLIMENTARY_CREDIT_PLAN_NAME}`,
        minPhoneLength: 4,
        HeaderLogo: ConvoNow,
        FooterLogo: ConvoFooter,
        isUS: false,
        isAU: false,
        isUK: true,
        contactURL: 'https://go.convo.io/uk/contact',
        organizationSpelling: 'organisations',
        helpCenterLabel: 'Help Centre',
        captchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITEKEY,
        domain: 'uk.convo.io',
    },
};

const regionConfig = Config[`${process.env.REACT_APP_REGION}`];

export default regionConfig;
